import { adminEmails } from 'src/constants';

const isAdmin = (email: string): boolean => {
  const admins = adminEmails.map((email) => email.toLowerCase());
  const isUserAdmin = admins.includes(email.toLowerCase());

  return isUserAdmin;
};

export default isAdmin;
